
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Eye, FileDown } from "lucide-react";
import { ResourceCardPreviewDialog } from "../ResourceCardPreviewDialog";

interface AdminActionsProps {
  resourceId: string;
  topic: string;
  company: string;
  previewImageUrl?: string | null;
  onPreviewClick?: () => void;
  isMobile?: boolean;
}

export function AdminActions({
  resourceId,
  topic,
  company,
  previewImageUrl,
  onPreviewClick = () => {},
  isMobile = false
}: AdminActionsProps) {
  const [previewDialogOpen, setPreviewDialogOpen] = useState(false);

  const handlePreviewClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    onPreviewClick();
    setPreviewDialogOpen(true);
  };

  // Add logging to confirm component rendering
  console.log("AdminActions rendering for resource:", resourceId);

  return (
    <div className="flex flex-col gap-4">
      <div className="flex gap-2">
        <Button 
          onClick={handlePreviewClick}
          className="flex-1"
          size={isMobile ? "sm" : "default"}
        >
          <Eye className="mr-2 h-4 w-4" />
          Preview Training
        </Button>
      </div>
      
      <ResourceCardPreviewDialog
        isOpen={previewDialogOpen}
        onOpenChange={setPreviewDialogOpen}
        resourceId={resourceId}
        topic={topic}
        company={company}
        isTrainee={false}
        isAdmin={true} // Explicitly setting isAdmin to true
        isResourceCompleted={false}
        isMobile={isMobile}
        onComplete={onPreviewClick}
      />
    </div>
  );
}
